module.exports = __webpack_public_path__ + "static/media/shaw-logo.6bf0bd2d.svg";